import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

export default function DataExplorerMap(){
  const map = useMap();
  map.zoomControl.setPosition("bottomleft");

  useEffect(() => {
    // Define the maximum and minimum latitude values
    const maxLat = 90; // Maximum latitude
    const minLat = -90; // Minimum latitude
    const maxLng = Infinity; // Maximum longitude
    const minLng = -Infinity; // Minimum longitude

    // Create a LatLngBounds object to represent the bounding box
    const bounds = L.latLngBounds(
      L.latLng(minLat, minLng), // Southwest corner
      L.latLng(maxLat, maxLng) // Northeast corner
    );

    // Set maximum bounds for the map
    map.setMaxBounds(bounds);

    // Add the tile layer to the map
    L.tileLayer(
      'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
    ).addTo(map);
  }, [map]);

  return null;
}